var map = {
	"./Account.svg": 520,
	"./Ehdot.svg": 521,
	"./Kyselyt.svg": 522,
	"./Reports.svg": 523,
	"./footer.png": 524,
	"./footer_colorized.png": 525,
	"./kipu.svg": 526,
	"./odum_logo_big.png": 52,
	"./odum_logo_small.png": 527,
	"./result_icon_07.png": 528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;